import {
  AddCollaboratorsHistoryProfessionalExperienceResponse,
  GetCollaboratorsHistoryProfessionalExperiencesResponse,
  SubmitCollaboratorsHistoryProfessionalExperienceRequest,
} from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryProfessionalExperiencesService = {
  async list(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryProfessionalExperiencesResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response =
      await httpClient.get<GetCollaboratorsHistoryProfessionalExperiencesResponse>(
        `v1/collaborators/${collaboratorId}/history/professional-experience?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },

  async add(
    collaboratorId: number,
    body: SubmitCollaboratorsHistoryProfessionalExperienceRequest,
  ): Promise<AddCollaboratorsHistoryProfessionalExperienceResponse> {
    const response = await httpClient.post<
      SubmitCollaboratorsHistoryProfessionalExperienceRequest,
      AddCollaboratorsHistoryProfessionalExperienceResponse
    >(
      `v1/collaborators/${collaboratorId}/history/professional-experience`,
      body,
    );
    return response;
  },

  async update(
    collaboratorId: number,
    experienceId: number,
    body: SubmitCollaboratorsHistoryProfessionalExperienceRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/professional-experience/${experienceId}`,
      body,
    );
  },

  async delete(collaboratorId: number, experienceId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/professional-experience/${experienceId}`,
    );
  },
};

export default CollaboratorsHistoryProfessionalExperiencesService;
